import { Component, Input } from '@angular/core';

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent {

  @Input() handleFileInput: (files: FileList) => void;

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  
    const files = event.dataTransfer?.files;
    if (files?.length && this.handleFileInput) {
      this.handleFileInput(files);
    }
  }

}
